/* eslint-disable */
import Vue from "vue";
import {findCommentHelper, findPostHelper} from "@/store/modules/helpers/helpers.js";
import $store from "@/store/index.js"

export function appendReactionToPost(state, { post, reaction}) {
	let postObject = findPostHelper(state, reaction.post_id);
	if(postObject) {
		const isMe = $store.getters['auth/user'].id == reaction.user.id

		if(isMe) {
			if (!postObject.my_reaction) {
				postObject.reactions_count++
			} else {
				postObject['reactions_' + postObject.my_reaction.type + '_count']--
			}
			Vue.set(postObject, 'my_reaction', reaction)
			postObject['reactions_' + reaction.type + '_count']++
		}
		else {
			postObject.reactions.push(reaction);
			postObject.reactions_count++
			postObject['reactions_' + reaction.type + '_count']++
		}
		return true;
	}
	return false;
}

export function appendReactionToComment(state, { comment, reaction }) {

	let post = findPostHelper(state, comment.post_id);

	if(post) {
		let commentObj = null
		if (comment.parent_id) {
			commentObj = findCommentHelper(state, post, comment.parent_id)
			commentObj = commentObj.answers.find(comment => comment.id === comment.id)
		} else {
			commentObj = findCommentHelper(state, post, comment.id)
		}
		if(commentObj) {
			const isMe = $store.getters['auth/user'].id == reaction.user.id
			if(isMe) {
				if (!commentObj.my_reaction) {
					commentObj.reactions_count++
				} else {
					commentObj['reactions_' + commentObj.my_reaction.type + '_count']--
				}

				Vue.set(commentObj, 'my_reaction', reaction)
				commentObj['reactions_' + reaction.type + '_count']++
			}
			else {
				commentObj.reactions_count++
				commentObj['reactions_' + reaction.type + '_count']++
			}
			return true;
		}
		return false;
	}
	return false;
}

export function removeReactionFromPost(state, { post, reaction }) {
	let postObject = findPostHelper(state, post.id)
	if(postObject) {
		const isMe = postObject.my_reaction && postObject.my_reaction.id == reaction.id;

		let reactionIdx = postObject.reactions.findIndex(x => x.id == reaction.id);
		if(isMe) {
			postObject['reactions_' + postObject.my_reaction.type + '_count']--
			postObject.reactions_count--;
			if(reactionIdx != -1) {
				postObject.reactions.splice(reactionIdx, 1);
			}
			Vue.set(postObject, 'my_reaction', null)
			return true;
		}
		else {

			let reactionObj = postObject.reactions.find(x => x.id == reaction.id);
			if(reactionObj && reactionObj.type) {
				postObject['reactions_' + reactionObj.type + '_count']--;
				postObject.reactions_count--;
				if(reactionIdx != -1) {
					postObject.reactions.splice(reactionIdx, 1);
				}

				return true;
			}
			return false;
		}
	}
	return false;

}

export function removeReactionFromComment(state, { comment, reactionID }) {
	let post = findPostHelper(state, comment.post_id);
	if(post) {
		let commentObj = null
		if (comment.parent_id) {
			commentObj = findCommentHelper(state, post, comment.parent_id)
			commentObj = commentObj.answers.find(comment => comment.id === comment.id)
		} else {
			commentObj = findCommentHelper(state, post, comment.id)
		}
		if(commentObj) {
			const isMe =commentObj.my_reaction && commentObj.my_reaction.id == reactionID;
			if(isMe) {
				commentObj['reactions_' + commentObj.my_reaction.type + '_count']--
				commentObj.reactions_count--
				Vue.set(commentObj, 'my_reaction', null)
			}
			else {
				let reactionObj = commentObj.reactions.find(x => x.id == reactionID);
				if(reactionObj) {
					commentObj['reactions_' + reactionObj.type + '_count']--
				}
				commentObj.reactions_count--
			}
			return true;
		}
		return false;
	}
	return false;
}

export function appendReactionToProblemIdea(state, { postID, problemIdeaId, reaction }) {
	let post = findPostHelper(state, postID);
	if(post) {
		let idea = post.postable.problem_ideas.find(x => x.id == problemIdeaId);
		if(idea) {
			const isMe = $store.getters['auth/user'].id == reaction.user.id;
			if(isMe) {
				Vue.set(idea, 'my_reaction', reaction);
			}
			idea.reactions_count ++;
			idea.reactions.push(reaction);
			idea['reactions_' + reaction.type + '_count']++;
			return true;
		}
		return false;
	}
	return false;


	// comment = findCommentHelper(state, post, commentID);
	// Vue.set(idea, 'my_reaction', reaction);
}

export function updateReactionToProblemIdea(state, { postID, problemIdeaId, reaction }) {
	let post = findPostHelper(state, postID);
	let idea = post.postable.problem_ideas.find(x => x.id == problemIdeaId)

	if(idea) {
		let idx = idea.reactions.findIndex(x => x.id == reaction.id);
		// Needs to be spliced because of a deep object change can take effect

		if(idx != -1) {
			const isMe = $store.getters['auth/user'].id == reaction.user.id;
			idea.reactions.splice(idx, 1);
			idea.reactions.push(reaction);
			if(isMe) {
				Vue.set(idea, 'my_reaction', reaction);
			}
			let old_reaction = idea.reactions.find(x => x.id == reaction.id);
			if(old_reaction) {
				idea['reactions_' + old_reaction.type + '_count']--;
				idea['reactions_' + reaction.type + '_count']++;
			}

			return true;
		}
		console.log("REACTION NOT FOUND IN STORE")
		return false;
	}
	console.log("IDEA NOT FOUND IN STORE")
	return false;
}

export function removeReactionFromProblemIdea(state, { postID, problemIdeaId, reactionID }) {
	let post = findPostHelper(state, postID);
	if(post) {
		let idea = post.postable.problem_ideas.find(x => x.id == problemIdeaId);
		if(idea) {
			const reactionIdx = idea.reactions.findIndex(x => x.id == reactionID);
			if(reactionIdx != -1) {
				const isMe = idea.my_reaction && idea.my_reaction.id == reactionID;
				if(isMe) {
					Vue.set(idea, 'my_reaction', null);
				}
				idea.reactions.splice(reactionIdx, 1);

				let reaction = idea.reactions[reactionIdx];
				if(reaction && reaction.type) {
					idea['reaction_' + reaction.type + '_count']--;
				}
			}
		}
	}
}

export function  updateReactionToPost(state, {postID, reaction}) {
	let post = findPostHelper(state, postID);
	if(post) {
		const isMe = $store.getters['auth/user'].id == reaction.user.id;
		if(isMe) {
			post.my_reaction = reaction;
		}
		let old_reaction = post.reactions.find(x => x.id == reaction.id);
		if(old_reaction) {
			post['reactions_' + old_reaction.type + '_count']--;
			post['reactions_' + reaction.type + '_count']++;
		}
	}
}

export function  updateReactionToComment(state, {postID, commentID, reaction}) {
	let post = findPostHelper(state, postID);
	if(post) {
		let comment = post.comments.find(x => x.id == commentID);
		if(comment) {
			const isMe = $store.getters['auth/user'].id == reaction.user.id;
			if(isMe) {
				comment.my_reaction = reaction;
			}
			let old_reaction = comment.reactions.find(x => x.id == reaction.id);
			if(old_reaction) {
				comment['reactions_' + old_reaction.type + '_count']--;
				comment['reactions_' + reaction.type + '_count']++;
			}
		}
	}
}
